import { Box, Flex, useBreakpoints } from "@otrium/core";
import { PromoText } from "src/molecules/PromoText";
import { localeFix } from "src/utils/genderLocale/genderLocale";
import { PromotionType, ShopType } from "src/types/graphql.d";

const BrandsPromoNonLoggedIn = ({
  slug,
  genderId,
}: {
  slug: string;
  genderId: string;
}): JSX.Element => {
  const { isDesktop } = useBreakpoints();
  const shopType = localeFix({ gender: genderId }) as ShopType;
  return (
    <>
      <Box
        display={
          isDesktop
            ? ["none", "none", "block"]
            : ["block", "block", "none", "none", "none"]
        }
      >
        {!isDesktop && (
          <>
            <Box mt={1} mb={3} width={1} data-testid="promo-text-mobile">
              <PromoText
                shopType={shopType}
                slug={slug}
                promotionType={PromotionType.Category}
              />
            </Box>
          </>
        )}

        {isDesktop && (
          <Flex mb={2} flexWrap="wrap" data-testid="promo-text-desktop">
            <Flex
              mt={2}
              alignItems="flex-end"
              justifyContent="flex-end"
              width={1}
            >
              <PromoText
                shopType={shopType}
                slug={slug}
                promotionType={PromotionType.Category}
              />
            </Flex>
          </Flex>
        )}
      </Box>
    </>
  );
};

export default BrandsPromoNonLoggedIn;
